/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */


export const getActivityAction = (customData) => {
    if (!(customData?.newValue ?? "")) {
        return "removed";
    } else if (!(customData?.oldValue ?? "")) {
        return "added";
    }
    return "updated";
}
